import styles from './SiteFooter.module.css';

/**
 * Brand mark plus the copyright line. The social links used to live here too,
 * but they now sit directly below the waitlist card as the "don't want emails?"
 * alternative - repeating them on a single-screen page was pure duplication.
 */
export function SiteFooter() {
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.brand}>
          <span className={styles.logo} aria-hidden="true">
            C<span className={styles.logoAccent}>r</span>
          </span>
          <span className={styles.name}>Creorank</span>
        </div>
        <span className={styles.copyright}>© 2026 Creorank. Copyrights Reserved.</span>
      </div>
    </footer>
  );
}
